<template lang="pug">
span.layout-snippet.layout-columns
  span.block(v-for='n in layoutCols-1', :class='{ gutter: n % config+1 === 1, faded: n > config }')
    span &block;
</template>

<script>

export default {
  props: {
    config: null,

    layoutCols: {
      type: Number,
      default: 12
    }
  }
}

</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.layout-snippet {
  display: inline-block;
  margin-left: 5px;
  margin-right: 7px;
  pointer-events: none;
  line-height: 1.85em;
}

.block {
  display: inline-block;
  margin-left: -1px;
  vertical-align: top;
  @include theme() {
  color: v(border);
  }

  .invalid & {
    @include theme() {
    color: v(urgent-01);
    }
  }

  &.gutter {
    @include theme() {
    color: v(canvas);
    }
  }

  &.faded:not(.gutter) {
    @include theme() {
    color: v(background);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Layouts/snippets/columns.vue